import { call, put, takeLatest, select } from "redux-saga/effects";
import request from "utils/request";
import { rosterImportActions } from "./index";
import { selectRosterRequests } from "./selector";
import { showToast } from "components/ToastContainer/index";

// Fetch roster requests
function* fetchRosterRequestsWorker(action) {
  try {
    const { page = 1, limit = 10, status = "pending" } = action.payload || {};
    const queryParams = new URLSearchParams({ page, limit });
    if (status) queryParams.append("status", status);

    const data = yield call(
      request,
      `/api/talent_roster_get?${queryParams.toString()}`,
      { method: "GET", credentials: "include" }
    );

    yield put(rosterImportActions.fetchRosterRequestsSuccess(data.data));
  } catch (error) {
    yield put(rosterImportActions.fetchRosterRequestsFailure(error.message));
  }
}

// Update roster request
function* UpdateTalentRosterSaga(action) {
  try {
    const payload = action.payload;

    const data = yield call(request, `/api/talent_roster_update`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });

    yield put(rosterImportActions.updateRosterRequestSuccess(data));
    showToast(data?.message, "success");

    //  Refresh table after update
    const rosterRequests = yield select(selectRosterRequests);
    const { pagination, status } = rosterRequests;

    yield put(
      rosterImportActions.fetchRosterRequests({
        page: pagination?.page || 1,
        limit: pagination?.limit || 10,
        status: status || "pending"
      })
    );
  } catch (error) {
    yield put(rosterImportActions.updateRosterRequestFailure(error.message));
    showToast(error?.message, "danger");
  }
}

export function* rosterImportSaga() {
  yield takeLatest(
    rosterImportActions.fetchRosterRequests.type,
    fetchRosterRequestsWorker
  );
  yield takeLatest(
    rosterImportActions.updateRosterRequest.type,
    UpdateTalentRosterSaga
  );
}
